<template>
  <div>
    <div class="form-header">
      <h1 class="title-screen">{{ adminText('workflowsAll.edit_attendee_field_translation_988bdc9', 'Edit attendee field translation') }}</h1>
      <div class="edit" @click="startEditing()">
        <img src="/assets/edit-pen.svg" :alt="adminText('workflowsAll.edit_icon_d1541cf', 'Edit icon')" class="edit-pen">
        <p class="edit-text">{{ adminText('workflowsAll.edit_17865bd', 'EDIT') }}</p>
      </div>
    </div>
    <div>
      <h3>{{ adminText('workflowsAll.select_language_daea52c', 'Select language') }}</h3>
      <p>
        {{ adminText('workflowsAll.select_a_language_for_which_you_are_creating__a9cf79e', 'Select a language for which you are creating a translation. You can choose your preferred language in your account settings.') }}
      </p>
      <v-select
        v-model="this.selectedLanguage"
        :disabled="true"
        :items="workflowUi(this.languages)"
        item-text="name"
        item-value="id"
        :label="adminText('workflowsAll.language_89b86ab', 'Language')"
      />
    </div>
    <div class="add-translation">
      <h3>{{ adminText('workflowsAll.add_your_translations_f18f1c7', 'Add your translations') }}</h3>
      <p>{{ adminText('workflowsAll.translate_your_event_title_and_attendee_field_be557ef', 'Translate your event title and attendee fields labels') }}</p>
      <div v-for="(attendeeField, index) in this.attendeeFields" :key="index">
        <div class="field">
          <div class="field-name">{{ workflowLabel(attendeeField) }}</div>
          <text-field
            v-model="form[attendeeField]"
            :label="workflowLabel(attendeeField)"
            class="field-input"
            :disabled="enableEditing"
          />
        </div>
      </div>
    </div>
    <div class="buttons">
      <div>
        <main-button flat :text="adminText('workflowsAll.cancel_1507c40', 'CANCEL')" @click="$emit('cancel')" />
        <main-button
          :text="adminText('workflowsAll.delete_d6f5636', 'DELETE')"
          color="#DB384C"
          :disabled="enableEditing"
          @click="deleteTranslation()"
        />
      </div>
      <main-button :text="adminText('workflowsAll.save_508156a', 'SAVE')" :disabled="enableEditing" @click="submit()" />
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { deleteEventTraslation, createOrUpdateEventTranslation } from './../../http'
export default {
  mixins: [WorkflowDisplay],
  name: 'new-translation',
  props: {
    languages: {
      default: [],
      type: Array,
    },
    existingTranslations: {
      default: {},
      type: Object,
    },
    selectedLanguage: {
      default: null,
      type: String,
    },
    languages: {
      default: [],
      type: Array,
    },
    attendeeFields: {
      default: [],
      type: Array,
    },
    eventId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      allLanguages: require('../../assets/languages.json'),
      isoLanguageShort: '',
      translationData: {},
      form: {},
      enableEditing: true,
    }
  },
  mounted() {
    Object.entries(this.allLanguages).find(([key, value]) => {
      if (value.name === this.selectedLanguage) {
        this.form = this.existingTranslations[key]
        this.isoLanguageShort = key
      }
    })
  },
  methods: {
    startEditing() {
      return (this.enableEditing = !this.enableEditing)
    },
    async submit() {
      this.translationData[this.isoLanguageShort] = { ...this.form }
      await createOrUpdateEventTranslation(Number(this.eventId), this.translationData)
      this.$emit('submit')
    },
    async deleteTranslation() {
      if (confirm(this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_translat_e9f69a9', 'Are you sure you want to delete this translation?'))) {
        await deleteEventTraslation(Number(this.eventId), this.isoLanguageShort)
        this.$emit('delete')
      }
    },
  },
}
</script>

<style scoped>
.add-icon {
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.5rem;
}
.screen-title {
  padding: 0 !important;
  margin-bottom: 2.25rem !important;
}
h3 {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #ff4c00;
  margin-bottom: 12px;
}
p {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
  margin-bottom: 24px;
}
.field {
  display: flex;
  flex-direction: row;
  column-gap: 3rem;
  align-items: center;
}
.field-name {
  flex-basis: 25%;
}
.field-input {
  flex-basis: 75%;
}
.add-translation {
  margin-top: 4.5rem;
}
.buttons {
  display: flex;
  justify-content: space-between;
}
.form-header {
  display: flex;
  justify-content: space-between;
  padding-top: 1.5rem;
}
.edit-text {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 1.125rem;
  color: #0277bd;
}
.edit {
  display: flex;
  justify-content: end;
  cursor: pointer;
}
.edit-pen {
  height: 1.125rem;
  width: 1.125rem;
  margin-top: 0.25rem;
  margin-right: 0.625rem;
}
.title-screen {
  margin-top: 0 !important;
}
</style>
